export default "__VITE_ASSET__C3rb8gF3__"